/* eslint-disable array-callback-return */
import React, { Component } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import ReactDOMServer from 'react-dom/server';
import _ from 'lodash';

class Dropzone extends Component {
  constructor(props) {
    super(props);

    this.dropzone = null;
    this.handleChange = this.handleChange.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  componentWillUpdate(nextProps) {
    let isChanged = false;
    if (!_.isEqual(this.dropzone.options.params, nextProps.djsConfig.params)) {
      this.dropzone.options.params = nextProps.djsConfig.params;
      isChanged = true;
    }
    if (this.dropzone.options.url !== nextProps.componentConfig.postUrl) {
      this.dropzone.options.url = nextProps.componentConfig.postUrl;
      isChanged = true;
    }

    if (isChanged) {
      this.handleChange({ isForceUpdate: true });
    }
  }

  handleChange(data) {
    const {
      djsConfig: { maxFiles },
      onChange,
    } = this.props;

    const isSameParallelUploads =
      this.dropzone.options.parallelUploads !== this.dropzone.getQueuedFiles().length;
    let isChanged = false;

    if ((data && data.isForceUpdate) || maxFiles) {
      isChanged = true;
    }

    if (!maxFiles && isSameParallelUploads) {
      this.dropzone.options.parallelUploads = this.dropzone.getQueuedFiles().length;
      isChanged = true;
    }

    if (isChanged) {
      onChange(this.dropzone);
      this.forceUpdate();
    }
  }

  handleSuccess(fileArr) {
    const { onSuccess } = this.props;

    onSuccess(fileArr);
  }

  handleError(fileArr) {
    const { onError } = this.props;

    onError(fileArr);
  }

  render() {
    const { dz, componentConfig, djsConfig, previewTemplate, layout, className } = this.props;

    if (previewTemplate) {
      djsConfig.previewTemplate = ReactDOMServer.renderToStaticMarkup(previewTemplate);
    }

    const eventHandlers = {
      init: (thisDz) => {
        dz &&
          dz.files &&
          dz.files.map((file) => {
            if (file) {
              // file.dataURL = URL.createObjectURL(file);
              thisDz.emit('addedfile', file);
              thisDz.emit('thumbnail', file, file.dataURL);
            }
          });
        this.dropzone = thisDz;
        this.handleChange({ isForceUpdate: true });
      },
      addedfiles: () => {
        const { files, options } = this.dropzone;
        if (options.maxFiles === 1 && files.length > options.maxFiles) {
          this.dropzone.removeFile(files[0]);
        }
        this.handleChange();
      },
      removedfile: () => this.handleChange(),
      success: (file, response) => {
        if (!djsConfig.uploadMultiple) {
          this.handleSuccess(response);
        }
      },
      successmultiple: (file, response) => {
        if (djsConfig.uploadMultiple) {
          this.handleSuccess(response);
        }
      },
      error: (file, response) => {
        this.handleError(response);
      },
    };

    return (
      <DropzoneComponent
        className={className}
        config={componentConfig}
        eventHandlers={eventHandlers}
        djsConfig={djsConfig}>
        {layout}
      </DropzoneComponent>
    );
  }
}

export default Dropzone;
